import ChevronRight from "@untitled-ui/icons-react/build/esm/ChevronRight";
import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Row,
  Statistic,
  Tag,
  Typography,
} from "antd";
import {
  SafetyOutlined,
  EditOutlined,
  SettingOutlined,
  DislikeOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import cnt from "../../../services/definedConstant";
import "../../../assets/styles/Bond.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import bondsList from "../../../config/data/bondsList.json";
import { apiConfig, labelConfig, staticConfig } from "./wallet.config";
import { handleFlgStatus } from "../../../components/facilities/AccountFacility";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { BOM } from "../../../services/definedMethod";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const ViewWallet = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state: selectedBondKey } = useLocation();

  const [walletDetails, setWalletDetails] = useState([]);

  const formatFullDate = (date) => {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const getWalletById = (params) => {
    const url = `${apiConfig.Wallet}/${params}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setWalletDetails(objDetail);
        console.log(walletDetails);
      }
    });
  };

  useEffect(() => {
    getWalletById(selectedBondKey);
  }, []);

  console.log(walletDetails);

  const dummyMenuItems = {
    items: [
      {
        label: "Modify Application",
        key: "1",
        route: "/savings-account-action",
        disabled: true,
        icon: <EditOutlined />,
      },
      {
        label: "Approve",
        key: "2",
        route: "/savings-account-action",
        disabled: true,
        icon: <SafetyOutlined />,
      },
      {
        label: "Reject",
        key: "3",
        route: "/savings-account-action",
        disabled: true,
        icon: <DislikeOutlined />,
      },
    ],
  };

  // Custom expand icon
  const expandIcon = ({ isActive }) => {
    return (
      <ChevronRight
        style={{
          fontSize: "8px",
          color: "#344054",
          display: "flex",
          alignItems: "center",
          transform: isActive ? "rotate(90deg)" : "rotate(0deg)",
          transition: "transform 0.2s ease",
        }}
      />
    );
  };

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return (
        <Text style={{ fontWeight: 500, color: "#6b7280" }}>
          {value || "-"}
        </Text>
      );
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem =
      index === (transformedData[section]?.items?.length || 0) - 1;

    const getDisplayValue = (val) => {
      if (val == null || val === "") return "-";
      if (typeof val === "object") return val.text || val.value;
      //  || JSON.stringify(val);
      return val.toString();
    };

    // Handle inline grouped fields (e.g. channels)
    if (item.isInlineGroup && Array.isArray(item.group)) {
      return item.group.map((fieldGroup, groupIndex) => (
        <div
          key={`inline-group-${section}-${index}-${groupIndex}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          <div
            style={{
              padding: "16px 24px",
              width: "50%",
              backgroundColor: "#f9f9f9",
              fontWeight: "500",
              borderRight: "1px solid #f0f0f0",
            }}
          >
            {fieldGroup.name}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              padding: "16px 24px",
              width: "50%",
              backgroundColor: "#fff",
            }}
          >
            {fieldGroup.fields.map((subField, subIndex) => (
              <div
                key={`inline-subfield-${subIndex}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 500,
                }}
              >
                {subField.isTag ? (
                  renderTag(getDisplayValue(subField.value))
                ) : (
                  <span>{getDisplayValue(subField.value)}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      ));
    }

    // Standard field row
    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isCustom ? (
            item.value
          ) : item.isTag ? (
            renderTag(getDisplayValue(item.value))
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {getDisplayValue(item.value)}
            </Text>
          )}
        </div>
      </div>
    );
  };

  const transformedData = [
    {
      section: "Product Information",
      items: [
        {
          name: "Product Name",
          value: walletDetails?.savingsProductData?.name ?? "-",
          isTag: true,
        },
        {
          name: "Product Type",
          value: walletDetails?.productTypeEnum?.value ?? "-",
          isTag: true,
        },
        {
          name: "Currency",
          value:
            walletDetails?.savingsProductData?.currency?.displayLabel ?? "-",
          isTag: true,
        },
        {
          name: "Use-cases",
          value: Array.isArray(walletDetails.useCases)
            ? walletDetails.useCases.map((useCase, index) => {
                return (
                  <span
                    key={useCase.id || index}
                    style={{
                      // marginRight: 8,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {renderTag(useCase.value)}
                  </span>
                );
              })
            : renderTag(walletDetails?.useCases?.value ?? "-"),
          isCustom: true,
        },
        {
          name: "External Identifier",
          value: walletDetails?.externalIdEnum ?? "-",
          isTag: true,
        },
        {
          name: "Minimum Sub Wallet",
          value: walletDetails?.minSubwallet ?? "-",
        },
        {
          name: "Maximum Sub Wallet",
          value: walletDetails?.maxSubwallet ?? "-",
        },
        {
          name: "Start Date",
          value: formatFullDate(walletDetails?.startDate) ?? "-",
        },
        {
          name: "End Date",
          value: formatFullDate(walletDetails?.endDate) ?? "-",
        },
      ],
    },
    {
      section: "Customer Eligibility",
      items: [
        {
          name: "KYC Level",
          value: walletDetails?.kycLevel ?? "-",
          isTag: true,
        },
        {
          name: "Minimum Age",
          value: walletDetails?.minimumAge + " years" ?? "-",
        },
        {
          name: "Transaction Restriction",
          value: Array.isArray(walletDetails?.transactionRestrictions) ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {walletDetails.transactionRestrictions.map((segment, index) => (
                <span key={segment.id || index}>
                  {renderTag(segment.value)}
                </span>
              ))}
            </div>
          ) : (
            renderTag(walletDetails?.transactionRestrictions?.value ?? "-")
          ),
          isCustom: true,
        },
        {
          name: "Customer Segment",
          value: Array.isArray(walletDetails?.customerSegments) ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {walletDetails.customerSegments.map((segment, index) => (
                <span key={segment.id || index}>
                  {renderTag(segment.value)}
                </span>
              ))}
            </div>
          ) : (
            renderTag(walletDetails?.customerSegment?.value ?? "-")
          ),
          isCustom: true,
        },
      ],
    },
    {
      section: "Account Parameters",
      items: [
        {
          name: "Maximum Wallet Balance",
          value: walletDetails?.maximumWalletBalance
            ? "₦ " + Number(walletDetails.maximumWalletBalance).toLocaleString()
            : "₦ -",
        },
        {
          name: "Daily Transaction Limit",
          value: walletDetails?.dailyTransactionLimit
            ? "₦ " +
              Number(walletDetails.dailyTransactionLimit).toLocaleString()
            : "₦ -",
        },
        {
          name: "Interest Bearing",
          value:
            (walletDetails?.savingsProductData
              ?.minBalanceForInterestCalculation ?? null) != null ||
            (walletDetails?.savingsProductData?.nominalAnnualInterestRate ??
              null) != null
              ? "Yes"
              : "No",
          isTag: true,
        },
        {
          name: "Minimum Balance for Interest",
          value: walletDetails?.savingsProductData
            ?.minBalanceForInterestCalculation
            ? "₦ " +
              Number(
                walletDetails?.savingsProductData
                  ?.minBalanceForInterestCalculation
              ).toLocaleString()
            : "₦ -",
        },
        {
          name: "Interest Rate",
          value:
            walletDetails?.savingsProductData?.nominalAnnualInterestRate +
              " %" ?? "-",
        },
        {
          name: "Minimum Period for Interest",
          value:
            walletDetails?.savingsProductData?.lockinPeriodFrequency +
              " Days" ?? "-",
        },
        {
          name: "Dormancy Period",
          value: walletDetails?.savingsProductData?.daysToDormancy
            ? walletDetails?.savingsProductData?.daysToDormancy + " Months"
            : "-",
        },
        {
          name: "Statement Cycle",
          value: Array.isArray(walletDetails?.statementCycles) ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {walletDetails.statementCycles.map((segment, index) => (
                <span key={segment.id || index}>
                  {renderTag(segment.value)}
                </span>
              ))}
            </div>
          ) : (
            renderTag(walletDetails?.statementCycles?.value ?? "-")
          ),
          isCustom: true,
        },
      ],
    },
    {
      section: "Fees & Charges",
      items: [
        {
          name: "Charge Name",
          value: (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {walletDetails?.savingsProductData?.charges?.map(
                (segment, index) => (
                  <span key={segment.id || index}>
                    {renderTag(segment.name) || "jttty"}
                  </span>
                )
              )}
            </div>
          ),
          isCustom: true, // 👈 so renderRow uses item.value directly
        },
        // {
        //   name: "Cash-In Fee",
        //   value: walletDetails?.cashInFee
        //     ? "₦ " + Number(walletDetails.cashInFee).toLocaleString()
        //     : "₦ -",
        // },
        // {
        //   name: "Cash-Out Fee",
        //   value: walletDetails?.cashOutFee
        //     ? "₦ " + Number(walletDetails.cashOutFee).toLocaleString()
        //     : "₦ -",
        // },
        // {
        //   name: "Wallet-To-Wallet Transfer",
        //   value: walletDetails?.walletToWalletTransfer
        //     ? "₦ " +
        //       Number(walletDetails.walletToWalletTransfer).toLocaleString()
        //     : "₦ -",
        // },
        // {
        //   name: "Wallet-To-Bank Transfer",
        //   value: walletDetails?.walletToBankTransfer
        //     ? "₦ " + Number(walletDetails.walletToBankTransfer).toLocaleString()
        //     : "₦ -",
        // },
      ],
    },
    {
      section: "Channels & Access",
      items: walletDetails?.channelAccess?.map((channelItem) => ({
        isInlineGroup: true,
        group: [
          {
            name: channelItem?.channel
              ?.replace(/_/g, " ") // Replace underscores with spaces
              ?.toLowerCase()
              ?.replace(/\b\w/g, (c) => c.toUpperCase()), // Capitalize each word
            isTagGroup: true,
            fields: [
              {
                value: channelItem.transactionLimit
                  ? walletDetails?.savingsProductData?.currency?.code +
                    " " +
                    Number(channelItem?.transactionLimit).toLocaleString()
                  : "₦ -",
              },
              {
                value: channelItem.multiFactorAuth
                  ? "2FA Enabled"
                  : "2FA Disabled",
                isTag: true,
              },
            ],
          },
        ],
      })),
    },
    {
      section: "Accounting",
      items: [
        {
          name: "Income From Fee Account",
          value:walletDetails?.savingsProductData?.accountingMappings?.incomeFromFeeAccount?.name
        },
        {
          name: "Income From Interest",
          value:walletDetails?.savingsProductData?.accountingMappings?.incomeFromInterest?.name
        },
        {
          name: "Income From Penalty Account",
          value:walletDetails?.savingsProductData?.accountingMappings?.incomeFromPenaltyAccount?.name
        },
        {
          name: "Interest On Savings Account",
          value:walletDetails?.savingsProductData?.accountingMappings?.interestOnSavingsAccount?.name
        },
        {
          name: "Overdraft Portfolio Control",
          value:walletDetails?.savingsProductData?.accountingMappings?.overdraftPortfolioControl?.name
        },
        {
          name: "Savings Control Account",
          value:walletDetails?.savingsProductData?.accountingMappings?.savingsControlAccount?.name
        },
        {
          name: "Savings Reference Account",
          value:walletDetails?.savingsProductData?.accountingMappings?.savingsReferenceAccount?.name
        },
        {
          name: "Transfers In Suspense Account",
          value:walletDetails?.savingsProductData?.accountingMappings?.transfersInSuspenseAccount?.name
        },
        {
          name: "WriteOff Account",
          value:walletDetails?.savingsProductData?.accountingMappings?.writeOffAccount?.name
        },
       
      ],
    },
  ];

  return (
    <MainLayout pageItems={staticConfig.viewWalletItems}>
      <TopContent
        pageTitle={labelConfig.wallet}
        createPageTitle={labelConfig.viewWallet}
      />
      <Card
        headStyle={{ borderBottomWidth: 0 }}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <div layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
          <Row>
            <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.generalInfo}
            </Title>
          </Row>
          <Divider style={{ marginTop: 10 }} />
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Dropdown.Button
                menu={dummyMenuItems}
                icon={<SettingOutlined />}
                placement="topLeft"
              >
                Actions
              </Dropdown.Button>
            </Col>

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Card
                bordered={true}
                bodyStyle={{
                  paddingTop: 12,
                  paddingBottom: 12,
                  // paddingLeft: 24,
                }}
                hoverable={true}
                style={{ marginBottom: 24, backgroundColor: "#EAE7EC" }}
              >
                <Row>
                  <Col span={12}>
                    <Statistic
                      title={"Product Name"}
                      value={
                        walletDetails?.savingsProductData?.name ?? "Wallet Name"
                      }
                      valueStyle={{
                        fontSize: "16px",
                      }}
                    />
                    <Statistic
                      title={"Product Code"}
                      value={
                        walletDetails?.savingsProductData?.shortName ??
                        "321-233-977-128"
                      }
                      valueStyle={{
                        fontSize: "16px",
                      }}
                      formatter={(val) => val}
                    />
                  </Col>
                  <Col span={12}>
                    {walletDetails?.status
                      ? handleFlgStatus(
                          walletDetails?.status.text,
                          {
                            fontSize: 16,
                          },
                          false
                        )
                      : "-"}
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <Row
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 20,
            }}
          >
            {transformedData.map((section, index) => (
              <Col>
                <Collapse
                  className="custom-collapse"
                  // expandIconPosition="start"
                  expandIcon={<ChevronDown color="red" />}
                  style={{
                    backgroundColor: "transparent",
                    padding: 0,
                  }}
                >
                  <Panel
                    key={index + 1}
                    header={
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                        }}
                      >
                        {section.section}
                      </span>
                    }
                    style={{
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        border: "1px solid #f0f0f0",
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      {section?.items?.map((item, itemIndex) =>
                        renderRow(item, itemIndex, index)
                      )}
                    </div>
                  </Panel>
                </Collapse>
              </Col>
            ))}
          </Row>
        </div>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewWallet);
